import React, { useEffect } from 'react';
import { PageHero } from '../components/page/PageHero';
import { WhyLawyerLed } from '../components/page/WhyLawyerLed';
import { FinalCTA } from '../components/home/FinalCTA';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { MapPin } from 'lucide-react';
const VALUES = [{
  title: 'Qualified solicitors',
  body: 'A qualified solicitor is involved in your matter, so legal questions are answered properly rather than passed on.'
}, {
  title: '40+ years combined experience',
  body: 'Established property and legal experience supports clear advice from first review through to settlement.'
}, {
  title: 'Personal communication',
  body: 'You receive direct, practical guidance from the team handling your matter throughout the transaction.'
}];
export function About() {
  useEffect(() => {
    document.title = 'About L.A Property Law & Conveyancing | Australia';
    window.scrollTo(0, 0);
  }, []);
  return <main data-id="element-563" data-mp="1uh08zrbgmtl2">
      <PageHero eyebrow="about the firm" title="Australian property law with personal guidance." intro="L.A Property Law combines 40+ years of experience, qualified solicitors and clear communication to guide buyers, sellers and investors through their property journey." primaryLabel="Get a free quote" primaryAction="quote" data-id="element-564" data-mp="1uitev4e919s0" />

      <section className="px-5 md:px-6 py-10 md:py-14 bg-surface" data-id="element-565" data-mp="2dg4ewr7pg78i">
        <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-6 lg:gap-8 items-start" data-id="element-566" data-mp="2deb6p7hg1eye">
          <div data-id="element-567" data-mp="28fgrefioq8j1">
            <p className="eyebrow text-brand-blue mb-1" data-id="element-568" data-mp="2m8y9dvvq3d6y">
              how we work
            </p>
            <h2 className="font-serif text-3xl md:text-[2.6rem] text-ink leading-tight" data-id="element-569" data-mp="2i7cphqkrtyn9">
              Conveyancing is routine, until it isn't.
            </h2>
            <p className="mt-5 text-lg text-muted-ink leading-relaxed" data-id="element-570" data-mp="2w7nfysi65b7w">
              A transaction can change quickly when a title issue, an unsuitable
              special condition, a disclosure problem or an ownership-structure
              question appears. Having a property lawyer involved means those
              moments are handled with proper advice, not left to chance.
            </p>
            <p className="mt-4 text-lg text-muted-ink leading-relaxed" data-id="element-571" data-mp="1xtrqz8tfbu1z">
              The result is one coordinated process, from the first review of
              the contract through to settlement, with clear communication along
              the way.
            </p>
            <div className="mt-8" data-id="element-572" data-mp="2cjfqc4i1oin2">
              <Link to="/team" data-id="element-573" data-mp="2cie3z3vkw9q1">
                <Button variant="outline" size="lg" data-id="element-574" data-mp="2glsu4nd8e6h7">
                  Meet the legal team
                </Button>
              </Link>
            </div>
          </div>
          <div className="grid gap-3" data-id="element-575" data-mp="2lk43kwzm6eyw">
            {VALUES.map(v => <div key={v.title} className="h-full rounded-2xl bg-background border border-border p-5" data-id="element-576" data-mp="m93107uot1av">
                <h3 className="font-serif text-xl text-ink" data-id="element-577" data-mp="jnd69fmsjhea">{v.title}</h3>
                <p className="mt-2 text-muted-ink leading-relaxed" data-id="element-578" data-mp="jpg58p5x8kv5">{v.body}</p>
              </div>)}
            <a href="https://maps.google.com/?q=202+Elgin+Street+Carlton+VIC+3053" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-brand-blue font-semibold hover:underline" data-id="element-579" data-mp="eutsahk6yk8y">
              <MapPin className="w-4 h-4" data-id="element-580" data-mp="12lfxm12t9qf9" />
              202 Elgin Street, Carlton VIC 3053
            </a>
          </div>
        </div>
      </section>

      <WhyLawyerLed data-id="element-581" data-mp="sna0dwry98gq" />
      <FinalCTA data-id="element-582" data-mp="smqfc77063yh" />
    </main>;
}